import React, { useCallback } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { BasePopup, Button, HeaderTitle, Icon, Label } from '@atlas/ui';

export const ErrorPopup = ({
  data: { headerTitle, text = 'something_went_wrong_contact_support', title, withHeader = true },
  id,
}) => {
  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <BasePopup className={cx('error-modal', { 'no-header': !withHeader })}>
      {withHeader && (
        <HeaderTitle className="left border block-big size-xs" title={headerTitle}>
          <div className="header-title__children">
            <button onClick={handleClose} type="button">
              <Icon name="close" />
            </button>
          </div>
        </HeaderTitle>
      )}

      <div className="popup__content">
        <Icon className="error-modal__icon" name="error" />
        <Label className="popup__title" message={title} />
        <Label className="popup__text" message={text} />
      </div>

      <div className="popup__footer">
        <Button className="primary big block" label="ok" onClick={handleClose} />
      </div>
    </BasePopup>
  );
};

ErrorPopup.propTypes = {
  data: PropTypes.shape({
    headerTitle: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
    withHeader: PropTypes.bool,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
